import { render, staticRenderFns } from "./UserFamilyChildrenEdit.vue?vue&type=template&id=4f7c7012&"
import script from "./UserFamilyChildrenEdit.vue?vue&type=script&lang=js&"
export * from "./UserFamilyChildrenEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f7c7012')) {
      api.createRecord('4f7c7012', component.options)
    } else {
      api.reload('4f7c7012', component.options)
    }
    module.hot.accept("./UserFamilyChildrenEdit.vue?vue&type=template&id=4f7c7012&", function () {
      api.rerender('4f7c7012', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UserFamilyChildrenEdit.vue"
export default component.exports